import React from 'react';
import { PropTypes } from 'prop-types';
import { Switcher } from '../Switcher/Switcher';
import {
  StyledPaymentSwitcher,
  StyledSwitcherSide,
} from 'components/PaymentSwitcher/PaymentSwitcherStyles';

export const PaymentSwitcher = React.memo((props) => {
  const { enabled, toggle, maxDiscount = '', ...restProps } = props;

  const sub = maxDiscount ? `Save up to ${maxDiscount}` : '';
  return (
    <StyledPaymentSwitcher {...restProps}>
      <Switcher
        leftTitle={<StyledSwitcherSide>Billed Monthly</StyledSwitcherSide>}
        rightTitle={<StyledSwitcherSide sub={sub}>Billed Yearly</StyledSwitcherSide>}
        enabled={enabled}
        toggle={toggle}
      />
    </StyledPaymentSwitcher>
  );
});

PaymentSwitcher.propTypes = {
  enabled: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};
